import SelectCollection from '@widesk-ui/components/form/SelectCollection';
import createSelect     from '@widesk-ui/tools/createSelect';
import ThemeModel       from '@models/map/ThemeModel';
import { getIdFromUrn } from '@widesk-core/tools/identifier';

const Select = createSelect<typeof ThemeModel, {
	projectUrn: Urn;
}>(props => (
	<SelectCollection
		modelClass={ThemeModel}
		renderOption={m => m.renderName()}
		sortName="label"
		sortWay="asc"
		filters={{ project: getIdFromUrn(props.projectUrn) }}
		formAddEnabled={false}
		formEditEnabled={false}

		{...props}
	/>
));

export default Select;
